<template>
  <div class="season-switch-wrapper">
    <button type="button" class="btn-toggle-season" @click="toggleSeason">
      <font-awesome-icon :class="{ 'season-icon': true, 'icon-switch': animateIcon }" :icon="seasonIcon" :size="iconSize"/>
      <span class="bottom-nav-label">{{ this.$store.state.season == this.seasons.winter ? $t(`seasons.sommer`) : $t(`seasons.winter`) }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SeasonSwitch',
  data() {
    return {
      seasons: {
        summer: 'sommer',
        winter: 'winter'
      },
      selectedSeason: this.$store.state.season,
      winterIcon: ['fal', 'snowflake'],
      summerIcon: ['fal', 'sun'],
      animationStart: null,
      animateIcon: false,
      animationDuration: 500,
    }
  },
  props: {
    iconSize: {
      type: String,
      default: '1x'
    }
  },
  methods: {
    toggleSeason() {
      // animate switch
      window.requestAnimationFrame(this.animateRotateToggle)

      if (this.selectedSeason === this.seasons.summer) {
        this.selectedSeason = this.seasons.winter
      } else {
        this.selectedSeason = this.seasons.summer
      }

      this.$store.dispatch('updateSeason', this.selectedSeason)
      this.$router.push({name: 'home'})
    },
    animateRotateToggle(timestamp) {
      if (!this.animationStart) {
        this.animationStart = timestamp
      }

      let progress = timestamp - this.animationStart

      if (progress < this.animationDuration) {
        this.animateIcon = true
        window.requestAnimationFrame(this.animateRotateToggle)
      } else {
        this.animateIcon = false
        this.animationStart = null
      }
    }
  },
  computed: {
    seasonIcon() {
      if (this.$store.state.season == this.seasons.summer) {
        return this.winterIcon
      } else {
        return this.summerIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.season-switch-wrapper {
  .btn-toggle-season {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    margin: 0 4px 0 2px;

    .season-icon {
      font-size: rem-calc(26px);
      color: $dark-gray;

      &.icon-switch {
        animation: seasonToggle .25s infinite;
      }
    }
    span.bottom-nav-label {
      margin-top: 5px;
      color: $dark-gray;

      @media (max-width: 369px) {
        font-size: 0.8rem;
      }
    }

  }
}
</style>
